const GoogleMapHelper = {
  getCoordinates(field) {
    let coords = [];
    let multi = [];
    if (field.geometry.type === "Polygon") {
      field.geometry?.coordinates.map((c) => {
        coords = [];
        c.map((c1) => {
          if (c1.length > 2) {
            c1.forEach((c2) => {
              coords.push({ lat: c2[1], lng: c2[0] });
            });
          } else {
            coords.push({ lat: c1[1], lng: c1[0] });
          }
        });
        multi.push(coords);
        return true;
      });
      coords = multi;
    } else if (field.geometry.type === "MultiPolygon") {
      field.geometry?.coordinates.forEach((c) => {
        c.map((c1) => {
          coords = [];
          if (c1.length > 2) {
            c1.forEach((c2) => {
              coords.push({ lat: c2[1], lng: c2[0] });
            });
          } else {
            coords.push({ lat: c1[1], lng: c1[0] });
          }
          multi.push(coords);
          return true;
        });
      });
      coords = multi;
    }
    return coords;
  },

  getPolygonCenter(field) {
    let lowx,
      highx,
      lowy,
      highy,
      lats = [],
      lngs = [];
    field.geometry?.coordinates.map((c) => {
      c.map((c1) => {
        if (c1.length > 2) {
          c1.forEach((c2) => {
            lngs.push(c2[0]);
            lats.push(c2[1]);
          });
        } else {
          lngs.push(c1[0]);
          lats.push(c1[1]);
        }
      });
    });
    lats.sort();
    lngs.sort();
    lowx = lats[0];
    highx = lats[lats.length - 1];
    lowy = lngs[0];
    highy = lngs[lngs.length - 1];
    let center_x = lowx + (highx - lowx) / 2;
    let center_y = lowy + (highy - lowy) / 2;

    return { lat: center_x, lng: center_y };
  },

  getMapCenter(fields, bounds) {
    fields.map((field) => {
      field.geometry?.coordinates.map((c) => {
        c.map((c1) => {
          if (c1.length > 2) {
            c1.forEach((c2) => {
              bounds.extend({ lat: c2[1], lng: c2[0] });
            });
          } else {
            bounds.extend({ lat: c1[1], lng: c1[0] });
          }
        });
      });
    });
    return bounds;
  },
};
export default GoogleMapHelper;
